import { useEffect, useState } from "react";
import EmptyState from "../../../../Components/EmptyState/EmptyState";
import CreateJobModal from "../../../../Components/CreateJobModal/CreateJobModal";
import ApplicantsModal from "../ApplicantsModal/ApplicantsModal";
import ShareInviteModal from "../../../../Components/SharedInviteModal/SharedInviteModal";
import { loadJobs, editJob, deleteJob } from "../../../../services/jobService";
import { toDateInputValue } from "../../../../utils/dateUtils";
import "./OpenVacancies.scss";

// ─── Ícones ──────────────────────────────────────────────────────────────────
const IconEdit = () => (
  <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
  </svg>
);

const IconTrash = () => (
  <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
    <polyline points="3 6 5 6 21 6" /><path d="M19 6l-1 14H6L5 6" />
    <path d="M10 11v6M14 11v6" /><path d="M9 6V4h6v2" />
  </svg>
);

const IconPin = () => (
  <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
    <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z" /><circle cx="12" cy="10" r="3" />
  </svg>
);

const IconCalendar = () => (
  <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
    <rect x="3" y="4" width="18" height="18" rx="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" />
  </svg>
);

const IconMoney = () => (
  <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
    <line x1="12" y1="1" x2="12" y2="23" /><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
  </svg>
);

const IconCandidatos = () => (
  <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

const IconShare = () => (
  <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
    <circle cx="18" cy="5" r="3" /><circle cx="6" cy="12" r="3" /><circle cx="18" cy="19" r="3" />
    <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" /><line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
  </svg>
);

// ─── Componente principal ─────────────────────────────────────────────────────
export default function OpenVacancies() {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedJob, setSelectedJob] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [applicantsJob, setApplicantsJob] = useState(null);
  const [shareJob, setShareJob] = useState(null); // ← vaga cujo modal de compartilhar está aberto
  const [bonusJob, setBonusJob] = useState(null);

  const fetchJobs = async () => {
    try {
      const userId = localStorage.getItem("userId");
      const data = await loadJobs(userId);
      setJobs(data.filter(j => j.status === 'open'));
    } catch (err) {
      console.error("Erro ao carregar vagas:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchJobs(); }, []);

  const handleEdit = async (jobData) => {
    await editJob(selectedJob.id, jobData);
    await fetchJobs();
  };

  const handleDelete = async (jobId) => {
    if (!window.confirm("Tem certeza que deseja excluir esta vaga?")) return;
    await deleteJob(jobId);
    await fetchJobs();
  };

  if (loading) return <div className="ov-loading">Carregando vagas...</div>;

  if (jobs.length === 0) return <EmptyState message="Você não possui vagas abertas." />;


  return (
    <section className="ov-wrapper">
      <div className="ov-grid">
        {jobs.map(job => (
          <div key={job.id} className={`ov-card ${job.isUrgent ? 'ov-card--urgent' : ''}`}>

            {job.isUrgent && (
              <div className="ov-urgent-badge">▲ URGENTE</div>
            )}

            <div className="ov-card-header">
              <div className="ov-card-header">
                <div>
                  <h3 className="ov-title">
                    {job.title}
                  </h3>

                  <div className="ov-tags">

                    <span className="ov-tag">
                      {job.visibility === "public" && "🌍 Pública"}

                      {job.visibility === "private_link" && "🔒 Link Privado"}

                      {job.visibility === "private_invite" && "✉️ Convite"}
                    </span>

                    <span className="ov-tag ov-tag--status">
                      {job.publishStatus === "published"
                        ? "Publicado"
                        : "Agendado"}
                    </span>

                  </div>
                </div>
              </div>
            </div>

            <p className="ov-description">{job.description}</p>

            {job.bonusDescription && (
              <div className="ov-bonus">
                <span className="ov-bonus__badge">
                  🎁 Com Bônus
                </span>

                <button
                  className="ov-bonus__info"
                  onClick={() =>
                    setBonusJob(bonusJob?.id === job.id ? null : job)
                  }
                  title="Ver bônus"
                >
                  ⓘ
                </button>
              </div>
            )}

            {bonusJob?.id === job.id && (
              <div className="ov-bonus__content">
                {job.bonusDescription}
              </div>
            )}
            <div className="ov-divider" />

            {job.visibility === "private_link" && (
              <>
                <div className="ov-divider" />

                <div className="ov-private-link">
                  <span className="ov-private-link__label">
                    🔒 Link privado
                  </span>

                  <div className="ov-private-link__box">
                    <code>
                      {`${window.location.origin}/v/${job.privateSlug}`}
                    </code>

                    <button
                      onClick={() =>
                        navigator.clipboard.writeText(
                          `${window.location.origin}/v/${job.privateSlug}`
                        )
                      }
                    >
                      Copiar
                    </button>
                  </div>
                </div>
              </>
            )}

            {/* 🔧 Bloco de convite direto */}
            {job.visibility === "private_invite" && (
              <>
                <div className="ov-divider" />

                <div className="ov-private-link">
                  <span className="ov-private-link__label">
                    ✉️ Convite Direto
                  </span>
                  <p className="ov-invite-hint">
                    Compartilhe com seus freelancers favoritos.
                  </p>
                </div>
              </>
            )}

            <div className="ov-infos">
              <div className="ov-info-row">
                <IconPin />
                <span>{job.location}</span>
              </div>
              <div className="ov-info-row">
                <IconCalendar />
                <span>{toDateInputValue(job.date)} às {job.startTime}</span>
              </div>
              <div className="ov-info-row ov-info-row--money">
                <IconMoney />
                <span>R$ {Number(job.payment).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</span>
              </div>
            </div>

            <div className="ov-divider" />

            <div className="ov-actions">
              <button
                className="ov-btn ov-btn--candidatos"
                onClick={() => setApplicantsJob(job)}
              >
                <IconCandidatos /> Candidatos
              </button>

              {/* 🔧 Botão Compartilhar — só aparece pra vagas de convite direto */}
              {job.visibility === "private_invite" && (
                <button
                  className="ov-btn ov-btn--share"
                  onClick={() => setShareJob(job)}
                >
                  <IconShare /> Compartilhar
                </button>
              )}

              <button
                className="ov-btn ov-btn--edit"
                onClick={() => { setSelectedJob(job); setShowEditModal(true); }}
              >
                <IconEdit />
              </button>
              <button
                className="ov-btn ov-btn--delete"
                onClick={() => handleDelete(job.id)}
              >
                <IconTrash />
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Modal de candidatos */}
      {applicantsJob && (
        <ApplicantsModal
          job={applicantsJob}
          onClose={() => setApplicantsJob(null)}
        />
      )}

      {/* 🔧 Modal de compartilhar / convidar favoritos */}
      {shareJob && (
        <ShareInviteModal
          job={shareJob}
          onClose={() => setShareJob(null)}
        />
      )}

      {/* Modal de edição */}
      {showEditModal && selectedJob && (
        <CreateJobModal
          open={showEditModal}
          onClose={() => { setShowEditModal(false); setSelectedJob(null); }}
          initialData={selectedJob}
          initialDate={toDateInputValue(selectedJob.date)}
          isEditing
          criarVaga={async (jobData) => {
            await handleEdit(jobData);
          }}
        />
      )}
    </section>
  );
}